import { Request } from '@/classes/Request.ts'

export const removeOtherFee = async (
  districtId: number,
  studentAssignedFeeId: number
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/remove_other_fee/${districtId}`, {
        fee_id: studentAssignedFeeId
      })
      .then(() => {
        resolve()
      })
      .catch(err => {
        reject(err.responseText)
      })
  })
}
